// extracted by mini-css-extract-plugin
export default {"info-layout":"_fapxpj","infoLayout":"_fapxpj","icon-avatar":"_wf5pt7","iconAvatar":"_wf5pt7","pricing-cta":"_rae3if","pricingCta":"_rae3if"};